import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Cible / couverture — cercles concentriques duotone */
export const TargetIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Anneaux */}
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.25" />
      <circle cx="12" cy="12" r="9.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="6" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Centre menthe */}
      <circle cx="12" cy="12" r="2.5" fill="var(--equiply-icon-bg)" />
      <circle cx="12" cy="12" r="2.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
TargetIcon.displayName = "TargetIcon";
